import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../components/ui/Button";
import Input from "../components/ui/Input";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [password, setPassword] = useState("");
  const [authError, setAuthError] = useState("");
  const [authLoading, setAuthLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setAuthError("");
    setAuthLoading(true);
    try {
      await login(password);
      setPassword("");
      const dest = location.state?.from?.pathname || "/admin/upload";
      navigate(dest, { replace: true });
    } catch (err) {
      setAuthError(err.message || "Incorrect password.");
    } finally {
      setAuthLoading(false);
    }
  }

  return (
    <div className="min-h-screen w-full bg-collectors-bg text-black flex items-center justify-center p-6">
      <form onSubmit={handleLogin} className="w-full max-w-sm flex flex-col gap-8">
        <div>
          <h2 className="font-display text-4xl font-bold tracking-tight">Restricted Access</h2>
          <p className="font-mono text-xs uppercase tracking-widest text-collectors-gray mt-2">
            Enter password to continue
          </p>
        </div>

        <Input
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoFocus
        />

        {authError && (
          <p className="font-mono text-xs uppercase tracking-widest text-red-600">{authError}</p>
        )}

        <Button type="submit" disabled={authLoading || !password}>
          {authLoading ? "Checking..." : "Enter"}
        </Button>
      </form>
    </div>
  );
}